import React from 'react';

import {
	useLocation,
	useNavigate,
	useParams,
	useSearchParams,
} from 'react-router-dom';

import MerchantConfig from './MerchantConfig';

interface MerchantConfigPageProps {
	onBack?: () => void;
	onboardingMode?: boolean;
	onNavigateToOnboarding?: () => void;
	onOnboardingComplete?: () => void;
	mfe?: boolean;
}

const MerchantConfigPage: React.FC<MerchantConfigPageProps> = ({
	onBack: propsOnBack,
	onboardingMode: propsOnboardingMode,
	onNavigateToOnboarding: propsOnNavigateToOnboarding,
	onOnboardingComplete: propsOnOnboardingComplete,
	mfe,
}) => {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const location = useLocation();

	// Determine if we're in onboarding mode - either from props (HOC) or URL params
	const isOnboardingFromUrl = !id && searchParams.get('onboarding') === 'true';
	const isOnboardingFromPath = location.pathname.startsWith('/onboarding/');
	const isOnboardingMode =
		propsOnboardingMode || isOnboardingFromUrl || isOnboardingFromPath;

	const handleBack = () => {
		if (propsOnBack) {
			// Use the onBack provided by HOC wrapper
			propsOnBack();
		} else if (isOnboardingMode) {
			navigate('/onboarding');
		} else {
			navigate('/config');
		}
	};

	const handleOnboardingComplete = () => {
		if (propsOnOnboardingComplete) {
			// Use the onOnboardingComplete provided by HOC wrapper (this handles step completion)
			propsOnOnboardingComplete();
		} else {
			navigate('/onboarding');
		}
	};

	const handleNavigateToOnboarding = () => {
		if (propsOnNavigateToOnboarding) {
			propsOnNavigateToOnboarding();
		} else {
			navigate('/onboarding');
		}
	};

	return (
		<MerchantConfig
			configId={id}
			onBack={handleBack}
			onboardingMode={isOnboardingMode}
			onNavigateToOnboarding={handleNavigateToOnboarding}
			onOnboardingComplete={handleOnboardingComplete}
		/>
	);
};

export default MerchantConfigPage;
